import React, { Component } from 'react';

const container = {
	display:'flex',
	 margin: '0 auto',
  maxWidth: '1200',
  padding: '0 .5rem',
  flexFlow: 'row wrap',
  justifyContent: 'space-around'
}

const styles = {
	border:'3px solid black', 
	flex: '1 1 auto',
	height: '250',
	order: '1',
	margin: '1rem',
}

const aside = {
	border:'3px solid yellow', 
	flex: '0 1 auto',
	height: '250',
	order: '2',
	margin: '1rem',
}

export default class Experience extends Component {
	render() {
		return (
			<div style={container} className='projContainer'>
				<div style={aside}></div>
				<div style={styles}></div>
				<div style={styles}></div>	
			</div>
			)
		}
	}